import { FormInput, validateEmail } from 'components/shared/Forms/ReduxForm'
import Navigation from 'components/shared/Navigation/Navigation'
import config from 'config/config'
import logo from 'images/logo.svg'
import qodo from 'images/qodo.svg'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { resetForm, submitEmail, submitPassword } from 'redux/user'
import {
  Card,
  Container,
  Divider,
  Form,
  Grid,
  Icon,
  Image,
  List,
  Message,
  Segment,
} from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { email, passwordResetSuccess, askPass, currentUser } = state.user
  return { email, passwordResetSuccess, askPass, currentUser }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      submitEmail,
      resetForm,
      submitPassword,
      push,
    },
    dispatch
  )
}

class Login extends React.Component {
  componentWillReceiveProps(newProps) {
    const { currentUser, push } = newProps
    if (currentUser && currentUser.id) push(config.nodes.dashboard)
  }

  componentWillUnmount() {
    const { resetForm } = this.props
    resetForm()
  }

  render() {
    const { passwordResetSuccess, askPass, invalid } = this.props
    const { handleSubmit, submitEmail, submitPassword } = this.props

    return (
      <div>
        <Segment basic className="loginArea">
          <Container>
            <Grid centered stackable>
              <Grid.Row>
                <Grid.Column
                  width={12}
                  className="flex-center"
                  style={{ minHeight: '100px' }}>
                  <Image src={logo} size="small" className="logo" />
                </Grid.Column>
              </Grid.Row>
              <Divider hidden clearing />

              <Grid.Row>
                <Grid.Column width={12} className="flex-center">
                  <Card className="rounded login">
                    <Card.Content>
                      <Card.Header as="h1" content={I18n.t('login.title')} />
                      <Card.Meta content={I18n.t('login.email.header')} />
                    </Card.Content>
                    <Card.Content extra>
                      <Card.Description>
                        <Form error={invalid}>
                          <Field
                            component={FormInput}
                            validate={validateEmail}
                            autoComplete="username email"
                            autoFocus
                            readOnly={askPass}
                            name="email"
                            size="large"
                            label={I18n.t('global.email')}
                            placeholder={I18n.t('global.email')}
                          />
                          <Field
                            component={FormInput}
                            name="password"
                            label={I18n.t('global.password')}
                            autoComplete="current-password"
                            placeholder={I18n.t('global.password')}
                            type="password"
                            size="large"
                          />

                          <Message
                            info
                            hidden={!passwordResetSuccess}
                            size={'small'}
                            header={I18n.t('login.first_login.header')}
                            content={I18n.t('login.first_login.success')}
                          />

                          <Form.Button
                            fluid
                            primary
                            disabled={invalid}
                            content={I18n.t('global.continue')}
                            onClick={handleSubmit((formValues) => {
                              if (!formValues.password)
                                submitEmail(formValues.email)
                              else
                                submitPassword(
                                  formValues.email,
                                  formValues.password
                                )
                            })}
                          />
                        </Form>
                      </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      <List>
                        <List.Item>
                          <Icon name="angle right" />
                          <List.Content>
                            <div className="item">
                              <a href="mailto:info@bartscher.ch?subject=Acccount-Anfrage">
                                Kein Account?
                              </a>
                            </div>
                          </List.Content>
                        </List.Item>
                        <List.Item>
                          <Icon name="angle right" />
                          <List.Content>
                            <Navigation
                              render="link"
                              as="link-item"
                              node="user/forgot-password"
                            />
                          </List.Content>
                        </List.Item>
                      </List>
                    </Card.Content>
                  </Card>
                </Grid.Column>
              </Grid.Row>
              <Divider hidden clearing />
              <Grid.Row>
                <Grid.Column width={12} className="flex-center">
                  <Image src={qodo} size="tiny" style={{ opacity: 0.25 }} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </div>
    )
  }
}

Login = connect(mapStateToProps, mapDispatchToProps)(Login)
Login = reduxForm({ form: 'login' })(Login)
export default Login



// WEBPACK FOOTER //
// ./src/components/shared/Login/Login.jsx